/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Pop_Up_TitleInputs */

const en_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter Pack offer!`)
};

const ar_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض حزمة المبتدئين!`)
};

const de_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starterpaket-Angebot!`)
};

const es_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Oferta del paquete inicial!`)
};

const fr_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre sur le pack de démarrage !`)
};

const it_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta pacchetto iniziale!`)
};

const ja_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターターパックがお得！`)
};

const ko_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스타터 팩 특별 혜택!`)
};

const pt_br_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta do pacote inicial!`)
};

const ru_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стартовый набор по выгодной цене!`)
};

const th_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอแพ็กเริ่มต้น!`)
};

const tr_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç Paketi fırsatı!`)
};

const zh_cn_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新手礼包优惠！`)
};

const zh_tw_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新手禮包優惠！`)
};

/**
* | output |
* | --- |
* | "Starter Pack offer!" |
*
* @param {Starter_Pack_Pop_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_pop_up_title = /** @type {((inputs?: Starter_Pack_Pop_Up_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Pop_Up_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_pop_up_title(inputs)
	if (locale === "ar") return ar_starter_pack_pop_up_title(inputs)
	if (locale === "de") return de_starter_pack_pop_up_title(inputs)
	if (locale === "es") return es_starter_pack_pop_up_title(inputs)
	if (locale === "fr") return fr_starter_pack_pop_up_title(inputs)
	if (locale === "it") return it_starter_pack_pop_up_title(inputs)
	if (locale === "ja") return ja_starter_pack_pop_up_title(inputs)
	if (locale === "ko") return ko_starter_pack_pop_up_title(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_pop_up_title(inputs)
	if (locale === "ru") return ru_starter_pack_pop_up_title(inputs)
	if (locale === "th") return th_starter_pack_pop_up_title(inputs)
	if (locale === "tr") return tr_starter_pack_pop_up_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_pop_up_title(inputs)
	return zh_tw_starter_pack_pop_up_title(inputs)
});